import { RecentBg } from "./Icons/recentbg";
import { RecentBadge } from "./Icons/recentBadge";
import { RecentStars } from "./Icons/recentStars";
import { useTranslation } from "react-i18next";
import {
  NoRecentCourseOuter,
  NoRecentCourseCard,
  NoRecentCourseLeft,
  NoRecentCourseTitleBox,
  NoRecentCourseTitle,
  NoRecentCourseButton,
  NoRecentCourseRight,
  NoRecentCourseBg,
  NoRecentCourseBadge,
  NoRecentCourseStars,
} from "./style";

export const NoRecentCourse = () => {
  const { t } = useTranslation("common");
  return (
    <NoRecentCourseOuter>
      <NoRecentCourseStars>
        <RecentStars />
      </NoRecentCourseStars>

      <NoRecentCourseCard>
        <NoRecentCourseLeft>
          <NoRecentCourseTitleBox>
            <NoRecentCourseTitle>
              {t("kpecDashboard.noRecentCourse")}
            </NoRecentCourseTitle>
          </NoRecentCourseTitleBox>
          <NoRecentCourseButton>
            {t("kpecDashboard.selectCourse")}
          </NoRecentCourseButton>
        </NoRecentCourseLeft>

        <NoRecentCourseRight>
          <NoRecentCourseBg>
            <RecentBg />
          </NoRecentCourseBg>
          <NoRecentCourseBadge>
            <RecentBadge />
          </NoRecentCourseBadge>
        </NoRecentCourseRight>
      </NoRecentCourseCard>
    </NoRecentCourseOuter>
  );
};
